/**
 * ARKS Store - Collection & Search Facet Filters
 */

class ARKSFacetFilters {
  constructor() {
    this.form = document.querySelector('#FacetFiltersForm');
    this.sortSelect = document.querySelector('#SortBySelect');
    
    this.init();
  }

  init() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      });
    }

    if (this.form) {
      this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.form.submit();
        });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ARKSFacetFilters();
});
